import { DATASOURCE } from 'Constants'

const initialState = {
  rejected: 0,
  accepted: 0,
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.LICENSE_OVERAGE.LOADING:
      return {
        ...state,
        loading: true,
        rejected: 0,
        accepted: 0,
        claritiOverageCount: 0
      };
    case DATASOURCE.LICENSE_OVERAGE.KEY:
      let reject = 0;
      let surge = 0;
      let claritiOverage = 0
      const licenseExceededData = action.data.licenseExceeded || action.data
      licenseExceededData.forEach(item => {
        // admittance limiter sets the exceedLicenseCapacity field when the call is over the limit
        // true means the call was rejected, false means it was accepted as a surge call
        if (item.key_as_string === 'true') {
          surge = item.doc_count;
        } else if (item.key_as_string === 'false') {
          reject = item.doc_count;
        }
      });

      if (action.data.claritiExceeded) {
        action.data.claritiExceeded.forEach(item => {
          // for now try just summing stuff
          claritiOverage += item.doc_count;
        });
      }

      return {
        ...state,
        loading: false,
        rejected: reject,
        accepted: surge,
        claritiOverageCount: claritiOverage
      };
    default:
      return state;
  }
}
